const tones = {
  neutral: 'bg-[var(--color-warm-100)] text-[var(--color-warm-700)] border-[var(--color-warm-200)]',
  cream:   'bg-[var(--color-cream-200)] text-[var(--color-warm-800)] border-[var(--color-cream-300)]',
  recovery:'bg-[var(--color-recovery-50)] text-[var(--color-recovery-700)] border-[var(--color-recovery-100)]',
  action:  'bg-[var(--color-action-50)] text-[var(--color-action-700)] border-[var(--color-action-100)]',
  insight: 'bg-[var(--color-insight-50)] text-[var(--color-insight-700)] border-[var(--color-insight-100)]',
  danger:  'bg-[var(--color-danger-50)] text-[var(--color-danger-700)] border-[var(--color-danger-100)]',
  success: 'bg-[var(--color-success-50)] text-[var(--color-success-700)] border-[var(--color-success-100)]',
};

const sizes = {
  xs: 'h-5 px-2 text-[11px] gap-1',
  sm: 'h-6 px-2.5 text-[12px] gap-1',
  md: 'h-7 px-3 text-[13px] gap-1.5',
};

export default function Badge({
  tone = 'neutral',
  size = 'sm',
  dot = false,
  icon,
  className = '',
  children,
}) {
  return (
    <span
      className={`
        inline-flex items-center font-semibold
        border rounded-[var(--radius-full)]
        tabular-nums
        ${tones[tone]} ${sizes[size]} ${className}
      `}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dotColor(tone)}`} />}
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </span>
  );
}

function dotColor(tone) {
  const map = {
    neutral: 'bg-[var(--color-warm-400)]',
    cream:   'bg-[var(--color-warm-400)]',
    recovery:'bg-[var(--color-recovery-500)]',
    action:  'bg-[var(--color-action-500)]',
    insight: 'bg-[var(--color-insight-500)]',
    danger:  'bg-[var(--color-danger-500)]',
    success: 'bg-[var(--color-success-500)]',
  };
  return map[tone];
}
